import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/dist/ScrollTrigger';
import * as deviceDetect from 'react-device-detect';
import css from './index.module.scss';
import GroupcB from './groupcB';
import GroupcC from './groupcC';
import { useGlobal } from '@/utils/useGlobal';
import { CanvasKeyFrames } from '@/utils/canvaskeyframes';
import { handleDynamicPath } from '@/utils/handleDynamicPath';

const isSafari = deviceDetect.isSafari;
gsap.registerPlugin(ScrollTrigger);

export default function Comp() {
    const layoutW = typeof window !== 'undefined' ? window.innerWidth : 1120;
    const layoutH = typeof window !== 'undefined' ? window.innerHeight : 1042;
    const scaleWH = Math.max(layoutW, layoutH) * 2;
    let startNumScale = 0;
    const { useEffect, useState } = useGlobal();
    // 序列帧-1
    const maxIndex1 = 60;
    let canvasKeyFramesInstance1: any = null;
    let preFrame1: number;
    const createImgs1 = (maxIndex: number) => {
        const imageEleArr: any[] = [];
        const imageCount = maxIndex;
        return new Promise((resolve, reject) => {
            let loadImageCount = 0;
            for (let i = 0; i < imageCount; i++) {
                const imageEle = new window.Image();
                imageEleArr.push(imageEle);
                imageEle.onload = function () {
                    loadImageCount++;
                    if (loadImageCount >= imageCount) {
                        // 此时图片全部加载完成
                        resolve(imageEleArr);
                    }
                };
                imageEle.onerror = reject;

                const strIndex = `00${i}`.slice(-2);
                imageEle.src = handleDynamicPath(`/media/deltamax/pc/taitou/taitou_000${strIndex}.jpg`);
            }
        });
    };
    // 序列帧-2
    const [flagObj2, setFlagObj2] = useState({
        flaga: true,
        flagb1: false,
        flagb2: false,
        flagc: false,
    });
    const maxIndex2 = 60 * 4;
    let canvasKeyFramesInstance2: any = null;
    let preFrame2: number;
    const createImgs2 = (maxIndex: number) => {
        const imageEleArr: any[] = [];
        const imageCount = maxIndex;
        return new Promise((resolve, reject) => {
            let loadImageCount = 0;
            for (let i = 0; i < imageCount; i++) {
                const imageEle = new window.Image();
                imageEleArr.push(imageEle);
                imageEle.onload = function () {
                    loadImageCount++;
                    if (loadImageCount >= imageCount) {
                        // 此时图片全部加载完成
                        resolve(imageEleArr);
                    }
                };
                imageEle.onerror = reject;
                const strIndex = `00${i % 60}`.slice(-2);
                imageEle.src = handleDynamicPath(`/media/deltamax/pc/dualchargingCommon/warp_006${strIndex}.png`);
            }
        });
    };
    const setFlagObj2Callback = (index: number) => {
        let flaga = false;
        let flagb1 = false;
        let flagb2 = false;
        let flagc = false;
        const oneSplit = maxIndex2 / 4;
        const a1 = oneSplit,
            a2 = oneSplit * 2,
            a3 = oneSplit * 3;

        if (index >= 0 && index <= a1) {
            flaga = true;
        } else if (index > a1 && index <= a2) {
            flagb1 = true;
        } else if (index > a2 && index <= a3) {
            flagb2 = true;
        } else if (index > a3) {
            flagc = true;
        }

        setFlagObj2({
            flaga: flaga,
            flagb1: flagb1,
            flagb2: flagb2,
            flagc: flagc,
        });
    };

    // 序列帧-1
    useEffect(() => {
        // //在上一层时就触发下载
        const gsapdGroupc1 = gsap.timeline({
            scrollTrigger: {
                trigger: '.block-TabInfo',
                scrub: true,
                start: `0 top`,
                end: `+=${100}`,
                once: true,
                onEnter() {
                    const container = document.querySelector('#gsapdGroupc-canvas1');
                    if (!container) return;
                    createImgs1(maxIndex1).then((imgArr) => {
                        canvasKeyFramesInstance1 = new CanvasKeyFrames(container, 'array', imgArr, {
                            width: 1440,
                            height: 810,
                            fps: 30,
                        });
                    });
                },
            },
        });
        const gsapdGroupc2 = gsap.timeline({
            scrollTrigger: {
                trigger: '.gsapdGroupc',
                scrub: true,
                start: `${layoutH * 1 - 315} bottom`,
                end: `+=${layoutH * 0.5 + 315}`,
                onUpdate(self: any) {
                    const currentFrame = Math.floor(self.progress * (maxIndex1 - 1));
                    if (preFrame1 === currentFrame) return;
                    preFrame1 = currentFrame;
                    canvasKeyFramesInstance1 && canvasKeyFramesInstance1.goto(currentFrame);
                },
            },
        });
        gsapdGroupc1.scrollTrigger.refresh();
        gsapdGroupc2.scrollTrigger.refresh();
    }, []);

    useEffect(() => {
        // 显示闪电
        const gsapdGroupc4 = gsap.timeline({
            scrollTrigger: {
                trigger: '.gsapdGroupc',
                scrub: true,
                start: `${layoutH * 1.5} bottom`,
                end: `+=${layoutH * 0.5}`,
            },
        });
        //根据高度匹配放大倍数,以使高度满屏
        const canvas1Scale = layoutH / 810;
        gsapdGroupc4
            .to('#gsapdGroupc-canvas1', {
                scale: canvas1Scale,
                duration: 1,
            })
            .fromTo(
                '.gsapdGroupc .gsapdGroupB',
                {
                    opacity: 0,
                    scale: 1,
                },
                {
                    opacity: 1,
                    scale: canvas1Scale,
                    duration: 1,
                },
                0,
            );

        startNumScale += 2.1;
        const gsapdGroupc5 = gsap.timeline({
            scrollTrigger: {
                trigger: '.gsapdGroupc',
                scrub: true,
                start: `${layoutH * startNumScale} bottom`,
                end: `+=${layoutH * 5}`,
            },
        });
        gsapdGroupc5
            .to('.gsapdGroupc .gsapdGroupc-canvas1', {
                scale: canvas1Scale + 0.5,
                opacity: 0,
                duration: 0.5,
            })
            .to(
                '.gsapdGroupc .gsapdGroupB',
                {
                    scale: canvas1Scale + 0.5,
                    duration: 0.5,
                    ease: 'none',
                },
                0,
            )
            .to('.gsapdGroupc .gsapdGroupB', {
                scale: 50,
                duration: 3,
                ease: 'none',
            })
            .to(
                '.gsapdGroupc .gsapdGroupB .msg-b-mod-msgbox',
                {
                    opacity: 1,
                    duration: 0.5,
                },
                1,
            )
            .to(
                '.gsapdGroupc .gsapdGroupB .msg-b-mod-bg',
                {
                    scale: 8,
                    duration: 1,
                    ease: 'none',
                },
                1.5,
            )
            .to(
                '.gsapdGroupc .gsapdGroupB .msg-b-mod-a',
                {
                    scale: 1.2,
                    duration: 1,
                    ease: 'none',
                },
                1.5,
            )
            .to('.gsapdGroupc .gsapdGroupB .msg-b-mod-a', {
                opacity: 0,
                scale: 1.5,
                duration: 0.5,
            })
            .fromTo(
                '.gsapdGroupc .gsapdGroupB .msg-b-mod-b',
                {
                    opacity: 0,
                },
                {
                    opacity: 1,
                    duration: 0.5,
                },
            )
            .fromTo(
                '.gsapdGroupc .gsapdGroupC',
                {
                    width: 0,
                    height: 0,
                },
                {
                    width: scaleWH,
                    height: scaleWH,
                    duration: 2,
                },
            );

        gsapdGroupc4.scrollTrigger.refresh();
        gsapdGroupc5.scrollTrigger.refresh();
    }, []);

    // 序列帧-2
    useEffect(() => {
        // //在上一层时就触发下载
        const gsapdGroupc1 = gsap.timeline({
            scrollTrigger: {
                trigger: '.block-TabInfo',
                scrub: true,
                start: `0 top`,
                end: `+=${100}`,
                once: true,
                onEnter() {
                    const container = document.querySelector('#gsapdGroupc-canvas2');
                    if (!container) return;
                    createImgs2(maxIndex2).then((imgArr) => {
                        canvasKeyFramesInstance2 = new CanvasKeyFrames(container, 'array', imgArr, {
                            width: 730,
                            height: 560,
                            fps: 30,
                        });
                    });
                },
            },
        });
        const gsapdGroupc2 = gsap.timeline({
            scrollTrigger: {
                trigger: '.gsapdGroupc',
                scrub: true,
                start: `${layoutH * 6} bottom`,
                end: `+=${layoutH * 4}`,
                onUpdate(self: any) {
                    const currentFrame = Math.floor(self.progress * (maxIndex2 - 1));
                    if (preFrame2 === currentFrame) return;
                    preFrame2 = currentFrame;

                    setFlagObj2Callback(preFrame2);
                    // console.log('nowindex2', preFrame2);
                    canvasKeyFramesInstance2 && canvasKeyFramesInstance2.goto(preFrame2);
                },
            },
        });

        gsapdGroupc1.scrollTrigger.refresh();
        gsapdGroupc2.scrollTrigger.refresh();
    }, []);

    return (
        <>
            <div id="gsapdGroupc-trigger-1"></div>
            <div className={`${css.gsapdGroupc} gsapdGroupc ${isSafari ? 'isSafari' : ''}`}>
                <div className="ef-scroll-ani-total-box">
                    <div className="ef-scroll-ani">
                        <div className="ef-scroll-ani-trigger">
                            <div className="ef-scroll-ani-inter">
                                <div className="gsapdGroupc-canvas1" id="gsapdGroupc-canvas1"></div>
                            </div>
                        </div>
                    </div>

                    <div className="ef-scroll-ani ef-scroll-ani-GroupcB">
                        <div className="ef-scroll-ani-trigger">
                            <div className="ef-scroll-ani-inter">
                                <GroupcB />
                            </div>
                        </div>
                    </div>
                    <div className="ef-scroll-ani">
                        <div
                            className={`ef-scroll-ani-trigger ${flagObj2.flaga ? 'active-groupc-a' : ''} ${flagObj2.flagb1 ? 'active-groupc-b1' : ''} ${
                                flagObj2.flagb2 ? 'active-groupc-b2' : ''
                            } ${flagObj2.flagc ? 'active-groupc-c' : ''}`}
                        >
                            <div className="ef-scroll-ani-inter">
                                <GroupcC />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
